@for (facet of facets(); track facet.id) {
<app-card-item class="cursor-pointer rounded-xl" (click)="toggle.emit(facet)" [isGray]="true"
  [isCheckbox]="isCheckbox()" [isChevronIcon]="isChevronIcon()"
  [isChecked]="isChecked(facet)" [isDeleteIcon]="isDeleteIcon()" (delete)="delete.emit(facet)">
  <ng-container left>
    <div class="bg-blue rounded-full mr-4 w-[30px] h-[30px] flex items-center justify-center">
      <app-icon size="small" [name]="getFacetIcon(facet.lense.alias)" class="text-white"></app-icon>
    </div>
    <div>
      {{facet.title}}
      <p class="text-gray-500">
        {{facet.byline}}
      </p>
    </div>
  </ng-container>

  <ng-content select="[right]"></ng-content>
</app-card-item>
}
